<template>
  <div id="fill-application">

    <!-- 头部 -->
    <application-header
      :order-id="params.orderId"
      :applicant-id="params.applicantId"
      :order="order"
      :applicant="applicant"
      :submitting="submitting"
      :application-group-status="applicationGroupStatus"
      @formSubmitted="submitForm"
      @leave="leave"
    ></application-header>

    <!-- 申请表 -->
    <application-form
      ref="applicationForm"
      :backend-application-url="applicationUrl"
      :applicant-id="applicant.order_applicant_id"
      @applicationConfigLoaded="applicationConfigLoaded"
      @formSubmittdSuccess="formSubmittdSuccess"
      @updatedApplicationGroupStatus="updatedApplicationGroupStatus"
    ></application-form>
  </div>
</template>

<script>
import _ from 'lodash';
import order from '../../libs/order';

import Http from '../../libs/http';
import utils from '../../libs/utils';

import applicationHeader from './components/application-header';
import applicationForm from './components/application-form';

export default {
  name: 'fill-application',
  components: {
    applicationHeader,
    applicationForm,
  },
  data() {
    return {
      order,
      applicant: {},
      params: {
        orderId: +this.$route.params.oid,
        applicantId: +this.$route.params.aid,
      },
      submitting: false,
      applicationGroupStatus: {}, // 申请表组状态
    };
  },
  computed: {

    // 申请表链接保护
    applicationUrl() {
      if (this.applicant.application && this.applicant.application.application_url) {
        return this.applicant.application && this.applicant.application.application_url;
      }
      return '';
    },
  },
  methods: {

    // 获取订单数据
    getOrder() {

      // 这个order是在内存中存的一份信息, 之前没有用vuex, 所以使用了这种共享数据的模式
      if (!order.user_order_id || !order.application) {
        Http.post('/order_query', { user_order_id: this.params.orderId }).then((data) => {
          this.order = data;
          this.applicant = _.find(this.order.applicant, applicant => applicant.order_applicant_id === this.params.applicantId);

          // 再次回填数据
          utils.extend(order, data);
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },

    // 离开
    leave() {
      if (this.$refs.applicationForm.isApplicationDataChanged()) {
        this.$confirm('确认返回上一页？未保存的修改可能会丢失', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          history.back();
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {
        history.back();
      }
    },

    // 申请表配置加载成功
    applicationConfigLoaded(applicationConfig, applicationData) {
      const result = {};
      if (applicationConfig && applicationConfig.length) {
        applicationConfig.forEach((group) => {
          result[group.name] = typeof applicationData[group.name] !== 'undefined' ? applicationData[group.name] : false;
        });
      }
      this.applicationGroupStatus = result;
    },

    // 更新申请表组的状态
    updatedApplicationGroupStatus(newApplicationGroupStatus) {
      this.applicationGroupStatus = newApplicationGroupStatus;
    },

    // 响应内部提交申请表
    formSubmittdSuccess() {
      this.$router.replace({
        name: 'waittingForUpload',
        params: {
          oid: this.order.user_order_id,
        },
        query: {
          go_next_step: true,
        },
      });
    },

    // 表单提交
    submitForm() {
      this.submitting = true;
      this.$refs.applicationForm.applicationSubmit()
        .then(() => {
          this.submitting = false;
          this.formSubmittdSuccess();
        })
        .catch((errorMsg) => {
          utils.msg.error(errorMsg);
          this.submitting = false;
        });
    },
  },
  created() {
    this.getOrder();
  },
};
</script>

<style scoped lang="less">
@import  '../../assets/less/variable';
div#fill-application {
  width: 1000px;
  margin: 0 auto;
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/FillApplication.vue